import I18n from "i18n-js";
import DateHelper from "../DateHelper/DateHelper";
import numeral from "numeral";
import { format, parseISO } from "date-fns";
import React from "react";
import CurrencyInput from "../CurrencyInput/CurrencyInput";
import CustomerSelect from "../Selects/CustomerSelect";
import DatePickerInput from "../DatePickerInput/DatePickerInput";
import Switch from "../Switch/Switch";
import ErrorHelper from "../Errors/ErrorHelper";
import CreditCardForm from "../BookingFlow/CreditCardForm";

const VoucherBuilderGeneral = (props) => {
  return(
    <div>
      {renderGeneralDetails(props)}
      {renderPaymentSwitch(props)}
      {renderPaymentDetails(props)}
    </div>
  );
};

const renderGeneralDetails = (props) => {
  return(
    <div>
    <div className="row">
      <div className="col-md-2">
        <div className="form-group">
          <label>{I18n.t('amount')}*</label>
          {
            props.new_record
            ?
              <CurrencyInput
                name="amount"
                onChange={props.onChangeVoucherInputs}
                value={props.voucher.amount}
                className={ ErrorHelper.renderFieldClasses('amount', props.errors, 'form-control') }
                onChangeEventType={true}
              />
            :
              <div>{formatCurrency(props.voucher.amount)}</div>
          }
          {props.errors ? ErrorHelper.renderFieldErrors('amount', props.errors) : null}
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-2">
        <div className="form-group">
          <label>{I18n.t("send_date")}*</label>
          {props.new_record ? (
            <DatePickerInput
              selectedDate={
                props.voucher.delivery_date
                  ? DateHelper.parseDateFromBackend(
                      props.voucher.delivery_date
                    )
                  : ""
              }
              dateFormat={DateHelper.rubyToDateFNS(props.date_format)}
              className={ErrorHelper.renderFieldClasses(
                "delivery_date",
                props.errors
              )}
              customChangeHandler={props.onChangeVoucherInputs}
              customChangeSource={"syntheticTarget"}
              name={"delivery_date"}
              minDate={props.property_date}
            />
          ) : (
            <div>
              {props.voucher.delivery_date
                ? DateHelper.printDateToScreen(
                    props.voucher.delivery_date,
                    props.date_format
                  )
                : I18n.t("none")}
            </div>
          )}
          {ErrorHelper.renderFieldErrors("delivery_date", props.errors)}
        </div>
      </div>
      <div className="col-md-2">
        <div className="form-group">
          <label>{I18n.t('expiration_date')}</label>
          {
            props.new_record
              ?
                <DatePickerInput
                  selectedDate={props.voucher.expiration_date || ''}
                  dateFormat={DateHelper.rubyToDateFNS(props.date_format)}
                  className={''}
                  customChangeHandler={props.onChangeVoucherInputs}
                  customChangeSource={'syntheticTarget'}
                  name={'expiration_date'}
                  minDate={props.property_date}
                />
              :
              <div>{props.voucher.expiration_date ? DateHelper.printDateToScreen(props.voucher.expiration_date, props.date_format) : I18n.t('none')}</div>
          }
        </div>
      </div>
      {
        !props.new_record
        ?
        (<div className="col-md-2">
          <div className="form-group">
            <label>{I18n.t('voided')}</label>
            <div>
              {
                props.voucher.voided_at
                ? 
                (
                  DateHelper.printDateToScreen(
                    props.voucher.voided_at,
                    props.date_format + " " + props.time_format,
                    true
                  )
                )
                : 
                I18n.t('none')
              }
            </div>
          </div>
        </div>)
        :
        null
      }
    </div>

    <hr />

    <div className="row">
      <div className="col-md-4">
        <div className="form-group">
          <label>{I18n.t("recipient_customer")}*</label>
          {props.new_record ? (
            <div>
              <CustomerSelect
                onChange={props.onChangeCustomer}
                allowClear={true}
                customer={props.voucher.customer}
              />
              <div className="text-right" style={{marginTop: '3px'}}>
                <a href="/admin/customers/new" data-fullscreen="true" data-nested="true" className="modal-iframe"><strong>{I18n.t('new_customer')}</strong></a>
              </div>
            </div>
          ) : (
            <div>
              {props.voucher.customer
                ? `${props.voucher.customer.first_name} ${props.voucher.customer.last_name} (${props.voucher.customer.email})`
                : I18n.t("none")}
            </div>
          )}
        </div>
      </div>
    </div>
    <div style={{marginBottom: '15px'}}>{I18n.t('or')}</div>
    <div className="row">
      <div className="col-md-4">
        <div className="form-group">
          <label>{I18n.t("recipient_name")}*</label>
          {props.new_record ? (
            <input
              type="text"
              name="recipient_name"
              value={props.voucher.recipient_name}
              onChange={props.onChangeVoucherInputs}
              className={ErrorHelper.renderFieldClasses(
                "recipient_name",
                props.errors,
                "form-control"
              )}
            />
          ) : (
            <div>{props.voucher.recipient_name}</div>
          )}
          {ErrorHelper.renderFieldErrors("recipient_name", props.errors)}
        </div>
      </div>
      <div className="col-md-4">
        <div className="form-group">
          <label>{I18n.t("recipient_email")}*</label>
          {props.new_record ? (
            <input
              type="email"
              name="recipient_email"
              value={props.voucher.recipient_email}
              onChange={props.onChangeVoucherInputs}
              className={ErrorHelper.renderFieldClasses(
                "recipient_email",
                props.errors,
                "form-control"
              )}
            />
          ) : (
            <div>{props.voucher.recipient_email}</div>
          )}
          {ErrorHelper.renderFieldErrors("recipient_email", props.errors)}
        </div>
      </div>
    </div>
    <hr />
    <div className="row">
      <div className="col-md-4">
        <div className="form-group">
          <label>{I18n.t("message")}</label>
          {props.new_record ? (
            <textarea
              rows={7}
              name="message"
              value={props.voucher.message || ""}
              onChange={props.onChangeVoucherInputs}
              className={ErrorHelper.renderFieldClasses(
                "message",
                props.errors,
                "form-control"
              )}
            />
          ) : (
            <div>{props.voucher.message}</div>
          )}
        </div>
      </div>
    </div>
    {props.new_record ? <hr /> : null}
    </div>
  );
};

const renderPaymentSwitch = (props) => {
  if (props.new_record) {
    return(
      <div className="row">
        <div className="col-md-2">
          <div className="form-group">
            <label>{I18n.t('take_payment')}</label>
            <Switch
              onText="yes"
              offText="no"
              onChange={props.onChangeSwitch}
              value={props.takePayment}
              name="takePayment"
              switchId="voucher-take-payment-switch"
            />
          </div>
        </div>
      </div>
    );
  };
};

const renderPaymentDetails = (props) => {
  if (props.takePayment && props.new_record) {
    return(
      <div className="panel panel-default payment-wrapper">
        <div className="panel-body container">
          <div className="row">

            <div className='col-md-5' style={{ marginBottom: '0px' }}>
              <div className="form-group">
                <label>{I18n.t('payment_type')}</label>

                <select className='form-control' value={props.purchasePayment.paymentType} name="paymentType" onChange={props.onChangePaymentInputs} disabled={false} >
                  <option value="card">{I18n.t('card')}</option>
                  {props.cash_drawers && props.cash_drawers.length ? <option value="cash">{I18n.t('cash')}</option> : null}
                </select>
                
              </div>
            </div>

            <div className="col-md-5">
              <div className="form-group customer-group">
                <label>{I18n.t('payment_customer')}*</label>
                <CustomerSelect customer={props.purchasePayment.customer} allowClear={true} onChange={props.onChangePurchaseCustomer} error={(props.errors && props.errors.payment_customer && props.errors.payment_customer.length) ? true : false}/>
                <div className={"flexed new-payment-customer-wrapper " + (props.errors && props.errors.payment_customer && props.errors.payment_customer.length ? 'with-errors' : '')}>
                  {props.errors ? ErrorHelper.renderFieldErrors('payment_customer', props.errors) : null}
                  <a href="/admin/customers/new" data-fullscreen="true" data-nested="true" className="btn btn-link btn-xs modal-iframe new-customer-button">{I18n.t('new_customer')}</a>
                </div>
                {/* {props.errors ? ErrorHelper.renderFieldErrors('customer', props.errors) : null} */}
              </div>
            </div>
          </div>
          <div className="row">
            {renderPaymentTypeDetails(props)}
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  };
};

const renderPaymentTypeDetails = (props) => {
  if (props.purchasePayment.paymentType == 'card' && props.purchasePayment.customer && ((!props.purchasePayment.customer.cards || props.purchasePayment.customer.cards.length == 0) || props.displayNewCardForm) ) {
    return(
      <div className="col-md">
        {(props.purchasePayment.customer.cards && props.purchasePayment.customer.cards.length) ? <span> <a href="#" onClick={props.toggleAddNewCard}>{I18n.t('use_existing_card')}</a></span> : null}
        <CreditCardForm
          customer={props.purchasePayment.customer}
          card={props.purchasePayment.card}
          saveCard={true}
          disableNameOnCard={props.purchasePayment.disableNameOnCard}
          nameOnCardInputWidth='col-sm-5'
          onChangeCardInput={props.onChangeNameOnCard}
          renderFieldErrors={(string) => {
            return props.errors ? ErrorHelper.renderFieldErrors(string.slice(0, -6), props.errors) : null
          }}
          hasClassErrors={(string) => {
            return props.errors && props.errors[string.slice(0, -6)] ? true : false;
          }}
          stackedForm={true}
          />
      </div>
    );
  } else if (props.purchasePayment.paymentType == 'cash') {
    return renderCashDrawers(props);
  } else if (props.purchasePayment.paymentType == 'card' && props.purchasePayment.customer && props.purchasePayment.customer.cards.length) {
    return(
      <div className={"col-md " + (props.errors && props.errors.card ? 'has-errors' : '')}>
        <span> <a href="#" onClick={props.toggleAddNewCard}>{I18n.t('add_new_card')}</a></span>
        {renderCustomerCards(props)}
      </div>
    );
  };
};

const renderCashDrawers = (props) => {
  const cash_drawers = props.cash_drawers.map((cash_drawer) => {
    return <option key={cash_drawer.id} value={cash_drawer.id}>{cash_drawer.name}</option>
  });
  cash_drawers.unshift(<option key="none" value="" disabled={props.purchasePayment.cash_drawer_id ? true : false}>{I18n.t('choose')}</option>);


  return(
    <div className='col-md-5' style={{ marginBottom: '0px' }}>
      <div className="form-group" style={{ marginBottom: '0px' }}>
        <label>{I18n.t('cash_drawer')}*</label>
        <select className={ErrorHelper.renderFieldClasses('cash_drawer', props.errors, 'form-control')} name="cash_drawer_id" value={props.purchasePayment.cash_drawer_id} onChange={props.onChangePaymentInputs}>
          {cash_drawers}
        </select>
        {props.errors ? ErrorHelper.renderFieldErrors('cash_drawer', props.errors) : null}
      </div>
    </div>
  );
};



const renderCustomerCards = (props) => {
  const cards = props.purchasePayment.customer.cards.map((card) =>{
    return (
      <div className={"card " + (props.purchasePayment.card_id && props.purchasePayment.card_id == card.id ? 'card-selected' : '')} key={card.id}>
        <label onClick={() => {
          var syntheticTarget = { target: { name: 'card_id', value: card.id }}
          props.onChangePaymentInputs(syntheticTarget)
        }} 
          className="customer-cards-label" name='card_id'>
          <input type="radio" name="card_id" value={card.id} checked={props.purchasePayment.card_id && props.purchasePayment.card_id == card.id ? true : false} onChange={props.onChangePaymentInputs} />
          <span className={"credit-card-icon small " + card.brand}></span>
          {I18n.t('ending_in').toLowerCase()} <strong>{card.last_4}</strong> {I18n.t('exp')} <strong>{card.month}/{card.year}</strong> {I18n.t('last_payment')} <strong>{card.last_payment ? format(parseISO(card.last_payment.processed_at), DateHelper.rubyToDateFNS(props.date_format) + ' ' + DateHelper.rubyToDateFNS(props.time_format)) : I18n.t('none')} </strong>
        </label>
      </div>
    );
  });

  return cards;
};

const formatCurrency = (num) => {
  return I18n.t('number.currency.format.unit') + numeral(num / 100).format('0' + I18n.t('number.currency.format.delimiter') + '0.00');
};


export default VoucherBuilderGeneral;